
import { v4 as uuidv4 } from "uuid";
import { FeatureUserRating } from "@models";
import {
  // Creature,
  RollPlusUpgradable,
  SummonOption,
  // SummonOption2,
  CreateResourceOption,
  CreateItemOption,
  TransformOption,
  // AdaptationOption,
  UpgradableNumber,
  Condition
} from "@dndModels";

/**
 * These are spells and other abilities.  
 * I wanted to call them Abilities to make them more generic,
 * because I want to use this for things that aren't spells
 * (like Battlemaster Maneuvers, Weapon Attacks, Sneak Attack, etc).
 * 
 * bonus is a string, but it's complicated, so I'm going to 
 * define how it works here.
 * To help me make sure I understand it myself, I'm going to start
 * with some examples:
 * 
 * Weapon(die, bonus): 1 * {die} + {STR} + {bonus}
 * Range(die, bonus): 1 * {die} + {DEX} + {bonus}
 * Finesse(die, bonus): 1 * {die} + Max({STR},{DEX}) + {bonus}
 * SecondWeapon(die, bonus): 1 * {die} + {bonus}
 * SneakAttack(): Ceil({ClassLevel}/2) * {d6} 
 * 
 * EldritchBlast(): {d10} + ({Features[EldritchInvocations]}.includes("Agonizing Blast") ? {CHA} : 0)
 * Hex(): {d6}
 * BurningHands(slotLevel): (2 + {slotLevel}) * {d6}
 * CureWounds(slotLevel): {slotLevel} * {d8} + {SPM}
 * Note: Multiplier on a die roll doesn't mean roll once 
 * and then multiply.  
 * It means roll that many of it and sum.
 * Spells will each need their own formula.
 * And some will need two formulae, like Ice Knife.
 * Also Versatile weapons will pass different die based on 
 * one and two handed strikes.
 * 
 */
export class Potence {
  true_id = "";
  level = 1;
  rolls: RollPlusUpgradable = new RollPlusUpgradable();
  extra = "";
  summon_options: SummonOption[] = [];
  transform_options: TransformOption[] = [];
  // adaptation_options: AdaptationOption[] = [];
  create_resource: CreateResourceOption = new CreateResourceOption();
  create_item: CreateItemOption = new CreateItemOption();
  enhance_item_mik_ids: string[] = [];
  conditions_applied: string[] = [];
  condition_levels_applied: UpgradableNumber = new UpgradableNumber(1);
  remove_condition_levels = false;
  the_conditions: Condition[] = [];

  // Eventually I want to remove these
  // obj_filter: any = {};
  // transform_type: "Knowledge" | "List" = "Knowledge";
  // knowledge_usage_key: string = "";
  // creature_ids: string[] = [];

  constructor(obj?: any, log_it = false) {
    this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.level = obj.level ? obj.level : 1;
      this.rolls = obj.rolls ? new RollPlusUpgradable(obj.rolls) : new RollPlusUpgradable();
      if (obj.dice_count && this.rolls.count.isBasic() && this.rolls.count.base === 0) {
        this.rolls.count.base = +obj.dice_count;
      }
      if (obj.dice_size && this.rolls.size.isBasic() && this.rolls.size.base === 0) {
        this.rolls.size.base = +obj.dice_size;
      }
      this.extra = obj.extra ? obj.extra : "";
      this.summon_options = [];
      if (obj.summon_options && obj.summon_options.length) {
        for (const p of obj.summon_options) {
          this.summon_options.push(new SummonOption(p, log_it));
        }
      }
      this.transform_options = obj.transform_options && obj.transform_options.length ? obj.transform_options.map((o: any) => new TransformOption(o)) : [];
      // this.adaptation_options = obj.adaptation_options && obj.adaptation_options.length ? obj.adaptation_options.map((o: any) => new AdaptationOption(o)) : [];
      if (log_it) {
        debugger;
      }
      this.create_resource = obj.create_resource ? new CreateResourceOption(obj.create_resource) : new CreateResourceOption();
      this.create_item = obj.create_item ? new CreateItemOption(obj.create_item) : new CreateItemOption();
      if (obj.enhance_item_mik_ids) {
        this.enhance_item_mik_ids = obj.enhance_item_mik_ids;
      } else if (obj.enhance_item_mik_id && obj.enhance_item_mik_id !== "") {
        this.enhance_item_mik_ids = [obj.enhance_item_mik_id];
      }
      this.conditions_applied = obj.conditions_applied ? obj.conditions_applied : [];
      this.condition_levels_applied = obj.condition_levels_applied ? new UpgradableNumber(obj.condition_levels_applied) : new UpgradableNumber(1);
      this.remove_condition_levels = obj.remove_condition_levels ? obj.remove_condition_levels : false;

      // this.obj_filter = obj.obj_filter ? obj.obj_filter : (obj.transform_filter ? obj.transform_filter : {});
      // if (Object.keys(this.obj_filter).length === 0) {
      //   if (obj.transform_ids && obj.transform_ids.length > 0) {
      //     this.obj_filter["id"] = { "in": obj.transform_ids };
      //   }
      //   if (obj.transform_type && obj.transform_type.length > 0) {
      //     this.obj_filter["transform_type"] = { "in": [obj.transform_type] };
      //   }
      // }
      // this.transform_type = obj.transform_type ? obj.transform_type : "Knowledge";
      // this.knowledge_usage_key = obj.knowledge_usage_key ? obj.knowledge_usage_key : "";
      // this.creature_ids = obj.creature_ids ? obj.creature_ids : [];
      // if (Object.keys(this.obj_filter).length === 1 && 
      //   this.obj_filter["transform_type"] && 
      //   Object.keys(this.obj_filter["transform_type"]).length === 1 &&
      //   this.obj_filter["transform_type"]["in"] && 
      //   this.obj_filter["transform_type"]["in"].length === 1 && 
      //   this.obj_filter["transform_type"]["in"][0] === "Knowledge") {
      //   this.obj_filter = {};
      // }
    }
  }

  get potence_string() {
    let str = "";
    let count_str = "";
    if (!this.rolls.count.isBlank()) {
      count_str = this.rolls.count.getReplacerString();
    }
    let size_str = "";
    if (!this.rolls.size.isBlank()) {
      size_str = this.rolls.size.getReplacerString();
    }
    let flat_str = "";
    if (!this.rolls.flat.isBlank()) {
      flat_str = this.rolls.flat.getReplacerString();
      if (flat_str.startsWith("{cfs.current_ability_scores.")) {
        // console.log(flat_str);
        flat_str = flat_str.substring(28);
        // console.log(flat_str);
        flat_str = flat_str.substring(0, flat_str.length - 1);
        // console.log(flat_str);
      }
    }
    if (count_str.length > 0 && size_str.length > 0) {
      if (flat_str.length > 0) {
        str = `{potence_string.${count_str}.${size_str}.${flat_str}}`;
      } else {
        str = `{potence_string.${count_str}.${size_str}}`;
      }
    }
    return str;
  }

  get condition_damage_types() {
    return this.the_conditions.flatMap(o => o.damage_types);
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      level: this.level,
      rolls: this.rolls.toDBObj(),
      extra: this.extra,
      summon_options: this.summon_options.map(o => o.toDBObj()),
      transform_options: this.transform_options.map(o => o.toDBObj()),
      // adaptation_options: this.adaptation_options.map(o => o.toDBObj()),
      create_resource: this.create_resource.toDBObj(),
      create_item: this.create_item.toDBObj(),
      enhance_item_mik_ids: this.enhance_item_mik_ids,
      conditions_applied: this.conditions_applied,
      condition_levels_applied: this.condition_levels_applied.toDBObj(),
      remove_condition_levels: this.remove_condition_levels,
      // transform_ids: this.transform_ids,
      // obj_filter: this.obj_filter,
      // transform_type: this.transform_type,
      // knowledge_usage_key: this.knowledge_usage_key,
      // creature_ids: this.creature_ids
    };
  }

  clone(drop_ids = false): Potence {
    const new_obj = new Potence();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy(copyMe: Potence, drop_ids = false): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.extra = copyMe.extra;
    this.level = copyMe.level;
    this.rolls = copyMe.rolls.clone(drop_ids);
    this.summon_options = copyMe.summon_options.map(o => o.clone());
    this.transform_options = copyMe.transform_options.map(o => o.clone());
    // this.adaptation_options = copyMe.adaptation_options.map(o => o.clone());
    this.create_resource = copyMe.create_resource.clone();
    this.create_item = copyMe.create_item.clone();
    this.enhance_item_mik_ids = [...copyMe.enhance_item_mik_ids];
    this.conditions_applied = [...copyMe.conditions_applied];
    this.condition_levels_applied = copyMe.condition_levels_applied.clone();
    this.remove_condition_levels = copyMe.remove_condition_levels;
    // this.transform_ids = [...copyMe.transform_ids];
    // this.obj_filter = {...copyMe.obj_filter};
    // this.transform_type = copyMe.transform_type;
    // this.knowledge_usage_key = copyMe.knowledge_usage_key;
    // this.creature_ids = [...copyMe.creature_ids];
  }

  connectUserRatings(userRatings: FeatureUserRating[]) {
    this.summon_options.forEach(option => {
      option.connectUserRatings(userRatings);
    });
  }
}

// export class PotenceUpgradable {
//   true_id: string;
//   level: number;
//   rolls: RollPlusUpgradable;
//   extra: string;
//   summon_options: SummonOption[];
//   conditions_applied: string[] = [];

//   constructor(obj?: any) {
//     this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
//     this.level = obj ? obj.level : 1;
//     this.rolls = obj ? new RollPlusUpgradable(obj.rolls) : new RollPlusUpgradable();
//     this.extra = obj && obj.extra ? obj.extra : "";
//     this.summon_options = [];
//     if (obj && obj.summon_options && obj.summon_options.length) {
//       obj.summon_options.forEach((p: any) => {
//         this.summon_options.push(new SummonOption(p));
//       });
//     }
//     this.conditions_applied = obj && obj.conditions_applied ? obj.conditions_applied : [];
//   }

//   toDBObj(): any {
//     const summon_options: any[] = [];
//     this.summon_options.forEach(p => {
//       summon_options.push(p.toDBObj());
//     });
//     return {
//       true_id: this.true_id,
//       level: this.level,
//       rolls: this.rolls.toDBObj(),
//       extra: this.extra,
//       summon_options,
//       conditions_applied: this.conditions_applied
//     };
//   }

//   clone(drop_ids: boolean = false): PotenceUpgradable {
//     const new_obj = new PotenceUpgradable();
//     new_obj.copy(this, drop_ids);
//     return new_obj;
//   }

//   copy(copyMe: PotenceUpgradable, drop_ids: boolean = false): void {
//     if (!drop_ids) {
//       this.true_id = copyMe.true_id;
//     }
//     this.extra = copyMe.extra;
//     this.level = copyMe.level;
//     this.rolls = copyMe.rolls.clone(drop_ids);
//     this.summon_options = [];
//     copyMe.summon_options.forEach(so => {
//       this.summon_options.push(so.clone(drop_ids));
//     });
//     this.conditions_applied = [...copyMe.conditions_applied];
//   }

//   copyPotence(copyMe: Potence): void {
//     this.extra = copyMe.extra;
//     this.level = copyMe.level;
//     this.rolls = new RollPlusUpgradable();
//     this.rolls.copy(copyMe.rolls);
//     this.summon_options = [];
//     copyMe.summon_options.forEach(so => {
//       this.summon_options.push(so.clone(true));
//     });
//     this.conditions_applied = [...copyMe.conditions_applied];
//   }
// }
